import moment from 'moment'
import Config from '../Config'
import { getLocale } from './Localizer'

// Ngrx Utility Class for various functions like Date format, Phone number format etc.
class NgrxDateHelper {
  constructor () {
    // Maximum value for date
    this.DATE_MAXVALUE = '9999-12-31'

    // Minimum value for date(WCF)
    this.DATE_MINVALUE = '0001-01-01'

    // Minimum value for date(SQL)
    this.SQLDATE_MINVALUE = '1753-01-01'

    // Standard Date Format
    this.dateFormat = Config.dateFormat
  }

  get MaxDate () {
    return moment(this.DATE_MAXVALUE).valueOf()
  }

  get MinDate () {
    return moment(this.DATE_MINVALUE).valueOf()
  }

  get SqlMinDate () {
    return moment(this.SQLDATE_MINVALUE).valueOf()
  }

  // Set the date in pre-defined format by converting to local time zone
  SetDate (dateValue, dateFormat) {
    moment.locale(getLocale())
    // to ensure no moment warnings in console
    if (typeof dateValue === 'string') {
      dateValue = moment(dateValue, Config.defaultAPIDateFormat)
    }
    const dtVal = moment(dateValue)
    if (dtVal._isValid) {
      const dtValMS = dtVal.valueOf()
      if (dtValMS === this.MaxDate || dtValMS === this.MinDate || dtValMS === this.SqlMinDate) {
        return Config.defaultDateValue
      }
      return dtVal.local().format(dateFormat || this.dateFormat).replace('.', '')
    } else {
      return Config.defaultDateValue
    }
  }
}
const NgrxDate = new NgrxDateHelper()

export default NgrxDate



// WEBPACK FOOTER //
// ./src/util/NgrxDateHelper.js